import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import scrollToElement from 'scroll-to-element';

import MainHeader from 'components/shared/landing/main-header';
import { IconList, IconListItem } from 'components/shared/landing/icon-list';
import styles from './styles.module.scss';
import FormContact from 'components/form-contact';
import pageData from './page-data';
import parentHeader from 'assets/img/sel-pages/parents-header.jpg';
import parentBenefits from 'assets/img/sel-pages/parent-benefits.png';
import parentImpact from 'assets/img/sel-pages/parents-impact.jpg';
import teacherHeader from 'assets/img/sel-pages/educators-header.jpg';
import teacherBenefits from 'assets/img/sel-pages/teacher-benefits.jpg';
import teacherImpact from 'assets/img/sel-pages/educators-impact.jpg';
import studentHeader from 'assets/img/sel-pages/students-header.jpg';
import studentBenefits from 'assets/img/sel-pages/student-benefits.jpg';
import studentImpact from 'assets/img/sel-pages/students-impact.jpg';

import unytedLearning from 'assets/img/sel-pages/unyted-learning.jpg';
import competitionImage from 'assets/img/sel-pages/competition-image.jpg';
import 'components/containers/landing/template-styles.nomodules.scss';

const typeToImage = {
  parents: {
    header: parentHeader,
    benefitPicture: parentBenefits,
    impact: parentImpact,
  },
  educators: {
    header: teacherHeader,
    benefitPicture: teacherBenefits,
    impact: teacherImpact,
  },
  students: {
    header: studentHeader,
    benefitPicture: studentBenefits,
    impact: studentImpact,
  },
};

export default class AboutSelStakeholder extends Component {
  render() {
    const { match, history } = this.props;
    const { type } = match.params;

    if (!type || !pageData[type]) {
      history.push('/sel-for/educators');
    }

    const data = pageData[type];
    const backgroundHeader = typeToImage[type].header;

    return (
      <div className={styles.pageContainer}>
        <MainHeader
          header={data.headerTitle}
          onButtonClick={() => scrollToElement('#benefits')}
          buttonText="Find Out"
          buttonClassName="apple"
          image={backgroundHeader}
        />
        <div className={styles.selStakeholder}>
          <section id="benefits" className={styles.benefits}>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-lg-6 order-lg-1 order-2">
                  <div className={styles.textContainer}>
                    <h5>Benefits</h5>
                    <h2>{data.benefitValueProp}</h2>
                    <p>{data.benefitBody}</p>
                  </div>
                </div>
                <div className="col-12 col-lg-6 order-lg-2 order-1">
                  <div className={styles.marginLeft}>
                    <img
                      src={typeToImage[type].benefitPicture}
                      alt={`the benefits for ${type}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className={styles.notice}>
            <div className="container">
              <div className={styles.noticeInner}>
                <div className={`row p-4 ${styles.textContainer}`}>
                  <div className="col-12 col-lg-6">
                    <div className="d-flex h-100 flex-column justify-content-between">
                      <div>
                        <h4>Integrated and Explicit SEL</h4>
                        <p>
                          Social Emotional Learning is infused into the core of
                          the platform.
                        </p>
                      </div>
                      <div className={styles.ctaButton}>
                        <Link to="/sel-encyclopedia" className="button purple">
                          Learn more about SEL
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <h4>You'll Notice:</h4>
                    <IconList>
                      {data.benefitItems.map((benefit, index) => (
                        <IconListItem
                          key={index}
                          icon="check"
                          iconClassName="text-apple"
                        >
                          {benefit}
                        </IconListItem>
                      ))}
                    </IconList>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className={styles.learning}>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-lg-6">
                  <div className={styles.marginRight}>
                    <img
                      src={unytedLearning}
                      alt={`unyted learning for ${type}`}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className={styles.textContainer}>
                    <h5>Unyted Learning</h5>
                    <h2>{data.learningValueProp}</h2>
                    <p>{data.learningDescription}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className={styles.competition}>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-lg-6 order-lg-1 order-2">
                  <div className={styles.textContainer}>
                    <h5>Competition</h5>
                    <h2>{data.competitionValueProp}</h2>
                    <p>{data.competitionDescription}</p>
                  </div>
                </div>
                <div className="col-12 col-lg-6 order-lg-2 order-1">
                  <div className={styles.marginLeft}>
                    <img
                      src={competitionImage}
                      alt={`competitions in unyted for ${type}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className={styles.impact}>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-lg-6">
                  <div className={styles.marginRight}>
                    <img
                      src={typeToImage[type].impact}
                      alt={`unyted's impact on ${type}`}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className={styles.textContainer}>
                    <h5>Impact</h5>
                    <h2>{data.impactValueProp}</h2>
                    <p>{data.impact}</p>
                    {type === 'parents' ? (
                      <LinkContainer to="/sel-encyclopedia">
                        <button className="apple lg">
                          Learn More About SEL
                        </button>
                      </LinkContainer>
                    ) : (
                      <LinkContainer to="/educators">
                        <button className="apple lg">
                          See Details About Unyted Platform
                        </button>
                      </LinkContainer>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <article className={styles.contact}>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12">
                  <h2>Contact Us to Learn More</h2>
                  <FormContact
                    messageLabel={
                      type === 'parents'
                        ? 'Do you have any questions or comments?'
                        : 'School, Grade Level, and Subject Matter'
                    }
                  />
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    );
  }
}
